import { debounce as debounceHelper, throttle as throttleHelper } from "../index";

function decoratorGenerator(func: Function) {
  return function (...args: any[]) {
    return function decorator(_proto: any, _methodName: string, descriptor: PropertyDescriptor) {
      return {
        ...descriptor,
        value: func(descriptor.value, ...args),
      };
    };
  };
}

/**
 * bind the class method to the instantiated context of the class,
 * does not support set/get accessors currently
 *
 * @param {*} _proto - prototype chain of the class
 * @param {string} methodName - name of the method which gets decorated
 * @param {PropertyDescriptor} descriptor - the descriptor of the original method
 * @returns {Object}
 */
export function autobind(_proto: any, methodName: string, { value, ...descriptor }: PropertyDescriptor) {
  // return a getter which allows on first access, when `this` is defined, to then redefine the method bound to that context
  return {
    get() {
      const boundFunction = value.bind(this);

      Object.defineProperty(this, methodName, {
        ...descriptor,
        value: boundFunction,
      });

      return boundFunction;
    },
  };
}

export const debounce = decoratorGenerator(debounceHelper);
export const throttle = decoratorGenerator(throttleHelper);
